import groupBy from 'lodash/groupBy';
import { AggregationSection, ProductCollectionFilter } from '../../../../types';
import { SupportedSection, SectionGroup } from './types';
import { ProductCollectionNonNameSearchFilter } from '../filter/types';

export const isValidSection = (
  section: AggregationSection
): section is SupportedSection => {
  return [
    'ListSection',
    'ListTreeSection',
    'RangeSection',
    'RangeGroupSection',
    'BooleanSection',
  ].includes(section.__typename || '');
};

export const isFeaturedSection = (section: AggregationSection): boolean =>
  Boolean(section.featured);

export const isNotFeaturedSection = (section: AggregationSection): boolean =>
  !section.featured;

export const isGroupedSection = (section: AggregationSection): boolean =>
  !section.featured && Boolean(section.group);

export const isUngroupedSection = (section: AggregationSection): boolean =>
  Boolean(section.featured) || !section.group;

export const findUngroupedSections = (
  sections: AggregationSection[]
): SupportedSection[] =>
  sections.filter(isUngroupedSection).filter(isValidSection);

export const findGroupedSections = (
  sections: AggregationSection[],
  filters: ProductCollectionNonNameSearchFilter[]
): SectionGroup[] => {
  const aggregationsByGroup = groupBy(
    sections.filter(isGroupedSection).filter(isValidSection),
    'group'
  );
  return Object.entries(aggregationsByGroup).map(([title, groupSections]) => ({
    title,
    sections: groupSections,
    filterCount: filters.filter(filter =>
      groupSections.some(section => section.property === filter.property)
    ).length,
  }));
};

export const isDisabledSection = (section: AggregationSection) => {
  switch (section.__typename) {
    case 'ListSection':
      return !section.items || !section.items.length;
    case 'RangeSection':
      return section.min === section.max;
    default:
      return false;
  }
};

export const getSelectedListItems = (
  filter: ProductCollectionFilter | undefined
) => {
  if (!filter) return undefined;

  switch (filter.__typename) {
    case 'ProductCollectionTermFilter':
      return filter.value
        ? [{ id: filter.id, value: filter.value }]
        : undefined;

    case 'ProductCollectionTermsFilter':
      return filter.values
        ? filter.values
            .map((value, index) => ({ id: filter.ids[index], value }))
            .sort((a, b) => a.value.localeCompare(b.value))
        : undefined;

    default:
      return undefined;
  }
};
